export const SPLIT_ROW_DEFAULT_PERCENT = 66.6667;
export const SPLIT_ROW_MIN_PERCENT = 25;
export const SPLIT_ROW_MAX_PERCENT = 75;
export const SPLIT_ROW_KEY_STEP_PERCENT = 2;

export const SPLIT_ROW_STORAGE_PREFIX = 'ui.splitRow.';
export const SPLIT_ROW_PANE_SELECTOR = ':scope > .split-row__pane';
export const SPLIT_ROW_HANDLE_SELECTOR = ':scope > .split-row__handle';

export const SPLIT_ROW_SINGLE_CLASS = 'split-row--single';
export const SPLIT_ROW_DRAGGING_CLASS = 'split-row--dragging';

export const SPLIT_ROW_BASIS_PROPERTY = '--split-row-basis';
export const SPLIT_ROW_HANDLE_LEFT_PROPERTY = '--split-row-handle-left';
